var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "left-toolbar mb10" }, [
      _c(
        "button",
        { staticClass: "swb-btn-small swb-btn", on: { click: _vm.exportPdf } },
        [_vm._v("导出为pdf")]
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "payVoucherInfoPdf" } }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("资产付款单")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c(
            "tbody",
            { staticClass: "body" },
            [
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-weight": "600",
                      "background-color": "#efefef",
                      "font-size": "12px"
                    },
                    attrs: { colspan: "12" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "来源单据号：" + _vm._s(_vm.voucher.innerNo || "无")
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.buyerName))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerName))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.buyerAddr))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerAddr))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.taxPayerNo))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "50px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerContactTel))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerContactName))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.voucher.buyerContactName))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "5", rowspan: "2" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerAcctNo))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(12),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.voucher.buyerComName))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "5", rowspan: "2" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(13),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.sellerBankName))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(14),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.voucher.buyerComContactName))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(15),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.voucher.buyerComContactTel))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "5", rowspan: "2" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(16),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.payPhaseName))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _vm._m(17),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.voucher.buyerComAddr))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(18),
              _vm._v(" "),
              _vm._l(_vm.voucher.itemList, function(item, index) {
                return _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      },
                      attrs: { colspan: "3" }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s(item.no))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      },
                      attrs: { colspan: "3" }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s(item.title))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s(item.quantity))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s(item.revcQuantity))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s((item.price || 0).toFixed(2)))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s((item.taxRate || 0).toFixed(2)))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s(item.unit))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "14px"
                      }
                    },
                    [
                      _c("span", { staticStyle: { display: "inline-block" } }, [
                        _vm._v(_vm._s((item.amount || 0).toFixed(2)))
                      ])
                    ]
                  )
                ])
              }),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(19),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "center",
                      color: "#1a1a1a",
                      "font-weight": "600",
                      "font-size": "14px"
                    },
                    attrs: { colspan: "2" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s((_vm.voucher.sumNtxAmount || 0).toFixed(2)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(20),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "center",
                      color: "#1a1a1a",
                      "font-weight": "600",
                      "font-size": "14px"
                    },
                    attrs: { colspan: "2" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s((_vm.voucher.sumAmount || 0).toFixed(2)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(21),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "center",
                      color: "#1a1a1a",
                      "font-weight": "600",
                      "font-size": "14px"
                    },
                    attrs: { colspan: "4" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s((_vm.voucher.amount || 0).toFixed(2)))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(22),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "4" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v(_vm._s(_vm.voucher.amountCapital || ""))]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(23),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "4" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s((_vm.voucher.amountPaid || 0).toFixed(2))
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(24),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "4" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s((_vm.voucher.amountOwed || 0).toFixed(2))
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.voucher.payPhaseId != null
                ? _c("tr", { staticClass: "row" }, [
                    _vm._m(25),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "4" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  width: "76px",
                                  float: "left",
                                  color: "#1a1a1a",
                                  "font-weight": "600",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.voucher.payPhaseName))
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(26),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    },
                    attrs: { colspan: "4" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.voucher.totalAmount || 0).toFixed(2)
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(27),
              _vm._v(" "),
              _vm._m(28),
              _vm._v(" "),
              _vm._m(29),
              _vm._v(" "),
              _vm._m(30)
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "6" }
        },
        [_c("span", [_vm._v("订购单位信息")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "6" }
        },
        [_c("span", [_vm._v("供应厂商")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("公司名称：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("供方公司名称：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("公司地址：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("供方公司地址：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("公司税号：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "50px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("电话：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("联系人：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("联络人：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px"
        },
        attrs: { rowspan: "6" }
      },
      [
        _c(
          "div",
          { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "div",
              {
                staticClass: "label",
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("span", [_vm._v("付款信息：")])]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("银行账号：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "6" }
        },
        [_c("span", [_vm._v("收货信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("收货店名：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("开户行：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("收货人：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("电话：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("付款阶段：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("收货地址：")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("订单编号")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("品名(项目)")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("订购数量")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("实收数量")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("单价(元)")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("税率(%)")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("单位")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "14px"
          }
        },
        [_c("span", [_vm._v("含税总计(元)")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        }
      },
      [_c("span", [_vm._v("订单未税金额(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        }
      },
      [_c("span", [_vm._v("税金(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("总计金额(含税)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "8" }
      },
      [_c("span", [_vm._v("总       计(大写)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "8" }
      },
      [_c("span", [_vm._v("已 付 金 额(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "8" }
      },
      [_c("span", [_vm._v("未 付 金 额(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "8" }
      },
      [_c("span", [_vm._v("  本次付款阶段")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-weight": "600",
          "font-size": "14px"
        },
        attrs: { colspan: "8" }
      },
      [_c("span", [_vm._v("本次付款合计(元) ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { rowspan: "2" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("备注")])]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "11" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("制定人签字")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "76px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span")]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "11" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("审核人签字")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "76px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span")]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "4" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("核准")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "76px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "4" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("复核")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "76px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "4" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("财务签收")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "76px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span")]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "2" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    width: "76px",
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("附件信息")])]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "2" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("收货单")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "40px",
                    "margin-left": "5px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [
                  _c("span", {
                    staticStyle: {
                      display: "inline-block",
                      width: "14px",
                      height: "14px",
                      border: "2px solid #ddd"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "2" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("验收单")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "40px",
                    "margin-left": "5px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [
                  _c("span", {
                    staticStyle: {
                      display: "inline-block",
                      width: "14px",
                      height: "14px",
                      border: "2px solid #ddd"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "4" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("发  票")])]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "2" }
        },
        [
          _c(
            "div",
            { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
            [
              _c(
                "div",
                {
                  staticClass: "label",
                  staticStyle: {
                    float: "left",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [_c("span", [_vm._v("收  据")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value",
                  staticStyle: {
                    "padding-left": "40px",
                    "margin-left": "5px",
                    "white-space": "normal",
                    "word-break": "break-all"
                  }
                },
                [
                  _c("span", {
                    staticStyle: {
                      display: "inline-block",
                      width: "14px",
                      height: "14px",
                      border: "2px solid #ddd"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3982e576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3982e576","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/payment/PayVoucherInfoPdf.vue
// module id = 2704
// module chunks = 0